export default __webpack_public_path__ + "static/media/logo.46a5ae3f.svg";